import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class Button extends React.Component {
  render() {
    const {
      title,
      style,
      onClick,
      deleting,
      disabled,
      primary,
      icon,
      tiny,
      small,
      highlight,
      block,
      large,
      className
    } = this.props;
    return (
      <button
        type="button"
        tabIndex={-1}
        disabled={disabled}
        className={classNames("btn", className, {
          disabled: disabled,
          "btn-block": block,
          "btn-sm": small,
          "btn-xs": tiny,
          "btn-success": highlight,
          "btn-primary": primary,
          "btn-default": !primary,
          "btn-danger": deleting,
          "btn-lg": large
        })}
        onClick={!disabled ? onClick : undefined}
        style={style}
      >
        {icon && <i className={classNames("fa", icon)} />}
        {icon && title && <span>&nbsp;&nbsp;</span>}
        {title}
      </button>
    );
  }
}

export default Button;
